export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.14-0857.30",
  commitId: "f3ebd64ded8f39ece763f6f9661939ac36958b67",
  commitTime: "2026-10-14T08:57:30.000Z",
});
